import Vue from 'vue'
import VueRouter from 'vue-router'
import Quizzs from '@/views/Quizzs.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/quizzs/:id',
    name: 'Quizzs',
    component: Quizzs
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
